/* eslint-disable @hakio/no-untranslated-terminology -- flag panel copy is internal (staff-only), not tenant-facing */
import { Buildings, ClockCounterClockwise, Users } from "@phosphor-icons/react"
import { createFileRoute, notFound, Outlet } from "@tanstack/react-router"

import { Module } from "~/components/design-system/pages"
import { BreadcrumbWrapper } from "~/components/reusable/Breadcrumb"
import type { HeaderTab } from "~/components/reusable/HeaderTabs"
import NotFound from "~/components/reusable/NotFound"
import { FEATURE_FLAGS, isFeatureFlagKey } from "~/features/feature-flags"
import { EnvironmentBadge, FlagPanelProvider } from "~/features/feature-flags/pages"

export const Route = createFileRoute("/_auth/internal/feature-flags/$flagKey/_layout")({
  params: {
    parse: ({ flagKey }) => {
      if (!isFeatureFlagKey(flagKey)) throw notFound()
      return { flagKey }
    },
  },
  staticData: { skipSkuStoreData: true },
  component: RouteComponent,
  notFoundComponent: NotFound,
})

const TABS: HeaderTab[] = [
  { label: "Companies", path: "/internal/feature-flags/$flagKey", icon: <Buildings /> },
  { label: "Users", path: "/internal/feature-flags/$flagKey/users", icon: <Users /> },
  {
    label: "History",
    path: "/internal/feature-flags/$flagKey/history",
    icon: <ClockCounterClockwise />,
  },
]

/** One flag: its companies, user overrides and history as tabs beside the flag inspector. */
function RouteComponent() {
  const { flagKey } = Route.useParams()
  // Above the Module: the flag inspector renders in the Module's inspector slot, outside the
  // routed content.
  return (
    <FlagPanelProvider>
      <Module
        key={flagKey}
        breadcrumb={
          <BreadcrumbWrapper
            items={[
              { label: "Feature flags", href: "/internal/feature-flags" },
              { label: FEATURE_FLAGS[flagKey].name },
            ]}
          />
        }
        actions={<EnvironmentBadge />}
        tabs={{ items: TABS, path: "/internal/feature-flags/$flagKey" }}
      >
        <Outlet />
      </Module>
    </FlagPanelProvider>
  )
}
